import * as React from 'react';

export const useToggle = (initialBooleanValue: boolean) => {
	const [bool, setBool] = React.useState(initialBooleanValue);
	const setBoolLambda = React.useCallback((newBool: boolean) => () => setBool(newBool), []);
	return [bool, setBool, setBoolLambda] as const;
};
